import { render, staticRenderFns } from "./detailPayment.vue?vue&type=template&id=027c7196&scoped=true"
import script from "./detailPayment.vue?vue&type=script&lang=js"
export * from "./detailPayment.vue?vue&type=script&lang=js"
import style0 from "./detailPayment.vue?vue&type=style&index=0&id=027c7196&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027c7196",
  null
  
)

export default component.exports